"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "ICON_NAMES", {
  enumerable: true,
  get: function get() {
    return _IconNames["default"];
  }
});

exports["default"] = void 0;

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconNames = _interopRequireDefault(require("./IconNames"));

_semanticUiReact.Icon.propTypes = {
  name: _propTypes["default"].oneOf(_IconNames["default"])
};
var _default = _semanticUiReact.Icon;
exports["default"] = _default;